import { request, qs } from './api';

// Destination moderation for the app's Popular / Trending lists.
// All endpoints require the admin JWT (handled by request()).

// GET /admin/moderate-destinations?type=popular|trending -> { data:{ type, destinations }, status }
export const loadDraft = (type) =>
  request(`/moderate-destinations${qs({ type })}`);

// POST /admin/moderate-destinations/remove { type, cities } -> refreshed 10-card draft
export const removeDestinations = (type, cities) =>
  request('/moderate-destinations/remove', { method: 'POST', body: { type, cities } });

// POST /admin/moderate-destinations/submit { type } -> publishes the draft live
export const submitDraft = (type) =>
  request('/moderate-destinations/submit', { method: 'POST', body: { type } });
